// Transitório (M1 -> M7): substitui user.role_name === 'Admin'.
// Sai com o usePermissions() do M7.
export function isOrgAdmin(user) {
  if (!user) return false;
  if (typeof user.is_org_admin === 'boolean') return user.is_org_admin;
  return user.role_name === 'Admin'; // backend sem o campo: janela da troca de diretórios ou rollback
}

export function hasCapability(user, cap) {
  return Array.isArray(user?.capabilities) && user.capabilities.includes(cap);
}

// Capabilities de backend/src/permissions/capabilities.js que cobrem a acao
// "Excluir" do menu da sidebar (na pratica um archiveBoard — mover pra
// lixeira). O backend exige rank 'owner' no quadro E uma dessas duas
// (boardRules.js: classe archive_delete = board.archive + board.delete).
const ARCHIVE_OR_DELETE_BOARD_CAPS = ['board.archive', 'board.delete'];

// Contrato pos-M1a: cada board nas listagens da sidebar (GET /workspaces
// e GET /boards) passa a trazer my_level ('viewer'|'contributor'|'editor'|
// 'owner'). Usado pra decidir quem ve Arquivar/Excluir no menu de opcoes
// do board na sidebar (BoardItemMenu/WorkspaceFolder/AppLayout).
//
// O backend exige, alem de my_level==='owner', a capability correspondente
// (board.archive ou board.delete) em user.capabilities — o criador Membro
// tem 'owner' mas o papel legado nao tem essas capabilities, e so isOwner
// levaria a um 403 ao clicar. isOrgAdmin sempre passa (rota de recuperacao).
//
// Fallback OBRIGATORIO: board.my_level ausente (backend M1a hoje em
// producao) -> regra antiga, so isOrgAdmin.
export function canManageBoardEntry(board, user) {
  if (board?.my_level != null) {
    if (isOrgAdmin(user)) return true;
    return board.my_level === 'owner' && ARCHIVE_OR_DELETE_BOARD_CAPS.some((cap) => hasCapability(user, cap));
  }
  return isOrgAdmin(user);
}

// Capabilities de organizacao que dao gestao de acesso de QUALQUER quadro
// (backend/src/permissions/boardRules.js: ORG_ACCESS_CAPABILITIES).
const ORG_ACCESS_CAPS = ['org.access.manage', 'org.boards.override'];

// Quem ve o item "Proteger" no menu do quadro — a senha que o quadro pede
// para abrir.
//
// Espelha BOARD_RULES['board.access'] do backend (classe manage_access): a
// mesma regra que guarda visibilidade e exceções do quadro. Nivel 'owner' NO
// QUADRO basta sozinho (o backend nao exige capability nenhuma nesse caso:
// rank >= 4 ja passa); sem 'owner', vale uma das capabilities de governanca
// da organizacao.
//
// Diferente de canManageBoardEntry (acima), que e a classe archive_delete e
// por isso exige board.archive/board.delete junto com o 'owner'.
//
// Fallback OBRIGATORIO: board.my_level ausente (backend pre-M1a) -> regra
// antiga, so isOrgAdmin.
//
// Isto e so a visibilidade do CONTROLE. Trocar ou remover a senha sem
// informar a atual e exclusividade do Proprietario, decidido no servidor
// (controllers/boardProtection.controller.js) — o cliente nao tem como saber
// quem e Proprietario e nao finge saber: oferece o caminho e mostra o erro
// que o servidor devolver.
export function canManageBoardProtection(board, user) {
  if (board?.my_level != null) {
    if (isOrgAdmin(user)) return true;
    if (board.my_level === 'owner') return true;
    return ORG_ACCESS_CAPS.some((cap) => hasCapability(user, cap));
  }
  return isOrgAdmin(user);
}

// Revisao de seguranca: criar area (POST /workspaces) e editar area — nome,
// icone, reordenar (PUT /workspaces/:id) — passam a exigir a capability
// org.workspace.create. Cliente e Colaborador nao tem e recebiam 403 ao
// clicar. Excluir area nao muda: continua so isOrgAdmin (WorkspaceDropdown
// ja trata onDelete separado, sem passar por esta funcao).
//
// Fallback OBRIGATORIO: user.capabilities ausente (backend M1a hoje em
// producao, /auth/me sem o campo) -> regra antiga, sempre liberado.
export function canManageWorkspaces(user) {
  if (!Array.isArray(user?.capabilities)) return true;
  return user.capabilities.includes('org.workspace.create');
}
